// extracted by mini-css-extract-plugin
module.exports = {"slide":"EnvironmentSlide_slide__7A2Hz","item":"EnvironmentSlide_item__zVouN"};